import { FootchinkoItem } from "./FootchinkoItem";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";

export class CactusPlank extends FootchinkoItem {

    constructor(game: Phaser.Game, x: number, y: number, rotation: number) {

        super(game, x, y, "texture_atlas_1", true, false, rotation);

        this.canBeHit = false;
        this.canBeAffectedByVoodoo = false;
    }

    public setBody(): void {

        this.body.setRectangle(190, 30, 0, 0);
        this.body.rotation = this.itemRotation;
        this.body.mass = 100;
        this.body.static = true;
        this.body.angularVelocity = 0;
        this.body.setMaterial(GameVars.getInstance().materials.pegMaterial);
    }

    public setView(): void {

        this.name = GameConstants.CACTUS_PLANK;

        this.burntFrameName = "burnt-electric-plank";
        this.frameName = "barra_elec_0001";

        // parte gráfica
        this.animations.add("irradiate", Phaser.Animation.generateFrameNames("barra_elec_", 1, 3, "", 4), 8, true);
        this.game.time.events.add(Math.random() * 500, function (): void {
            this.animations.play("irradiate");
        }, this);
    }

    public burn(): void {

        this.animations.stop("irradiate");
        super.burn();
    }
}
